import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BreadcrumbBase from '@/design-system/atoms/BreadcrumbBase.vue'
import IconChevronRight from '@/design-system/assets/icons/IconChevronRight.vue'
import { computed, toRefs } from 'vue'
import { BreadcrumbOption } from '@/utils/breadcrumbs'
import { DirectoryItem } from './types'
interface EMITS {
  (e: 'onClicked', option: DirectoryItem)
}
interface Props {
  breadcrumbs: DirectoryItem[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BreadcrumbFiles',
  props: {
    breadcrumbs: {}
  },
  emits: ["onClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { breadcrumbs } = toRefs(props)
const emits = __emit

const formattedBreadcrumbs = computed<BreadcrumbOption[]>(() =>
  breadcrumbs.value.map((item, index) => ({
    id: item.id,
    title: item.name,
    parentId: item.parentId ?? undefined,
    icon: index === 0 ? 'IconSmallPaperClip' : undefined
  }))
)

function onClicked(option: BreadcrumbOption) {
  const selectedItem = breadcrumbs.value.find((item) => item.id === option.id)
  if (selectedItem) {
    emits('onClicked', selectedItem)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BreadcrumbBase, {
    breadcrumbOptions: formattedBreadcrumbs.value,
    onOnClicked: onClicked
  }, {
    default: _withCtx(() => [
      _createVNode(IconChevronRight, { class: "breadcrumb-chevron__icon" })
    ]),
    _: 1
  }, 8, ["breadcrumbOptions"]))
}
}

})